//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "POSSUMandPPOSSUM",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
        value10: "",
        value11: "",
        value12: "",
      },
      form1: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "1", name: "≤60" },
        { value: "2", name: "61-70岁" },
        { value: "4", name: "≥71岁" },
      ],
      dataList1: [
        { value: "1", name: "无心衰" },
        { value: "2", name: "使用利尿药、强心药、抗心绞痛药及降压治疗" },
        { value: "4", name: "外周性水肿、服用华法林、交界性心脏增大" },
        { value: "8", name: "颈静脉压升高、心脏增大" },
      ],
      dataList2: [
        { value: "1", name: "无呼吸困难" },
        { value: "2", name: "劳累后呼吸困难、轻度COAD" },
        { value: "4", name: "限制性呼吸困难、中度COAD" },
        { value: "8", name: "静息时呼吸困难（频率≥30次/min）、重度COAD" },
      ],
      dataList3: [
        { value: "1", name: "110-130" },
        { value: "2", name: "131-170或100-109" },
        { value: "4", name: "≥171或90-99" },
        { value: "8", name: "≤89" },
      ],
      dataList4: [
        { value: "1", name: "50-80" },
        { value: "2", name: "81-100或40-49" },
        { value: "4", name: "101-120" },
        { value: "8", name: "≥121或≤39" },
      ],
      dataList5: [
        { value: "1", name: "15" },
        { value: "2", name: "12-14" },
        { value: "4", name: "9-11" },
        { value: "8", name: "≤8" },
      ],
      dataList6: [
        { value: "1", name: "130-160" },
        { value: "2", name: "115-129或161-170" },
        { value: "4", name: "100-114或171-180" },
        { value: "8", name: "≤99或≥181" },
      ],
      dataList7: [
        { value: "1", name: "4-10" },
        { value: "2", name: "10.1-20.0或3.1-4.0" },
        { value: "4", name: "≥20.1或≤3.0" },
      ],
      dataList8: [
        { value: "1", name: "≤7.5" },
        { value: "2", name: "7.6-10.0" },
        { value: "4", name: "10.1-15.0" },
        { value: "8", name: "≥15.1" },
      ],
      dataList9: [
        { value: "1", name: "≥136" },
        { value: "2", name: "131-135" },
        { value: "4", name: "126-130" },
        { value: "8", name: "≤125" },
      ],
      dataList10: [
        { value: "1", name: "3.5-5.0" },
        { value: "2", name: "3.2-3.4或5.1-5.3" },
        { value: "4", name: "2.9-3.1或5.4-5.9" },
        { value: "8", name: "≤2.8或≥6.0" },
      ],
      dataList11: [
        { value: "1", name: "正常" },
        { value: "4", name: "心房颤动（心率60-90次/min）" },
        {
          value: "8",
          name: "任何其他不正常节律或≥5次异位/min；Q波或ST/T波变化",
        },
      ],
      dataList12: [
        { value: "1", name: "小手术（一级）" },
        { value: "2", name: "中等难度手术（二级）" },
        { value: "4", name: "大手术（三级）" },
        { value: "8", name: "特大手术（四级）" },
      ],
      dataList13: [
        { value: "1", name: "1" },
        { value: "4", name: "2" },
        { value: "8", name: "＞2" },
      ],
      dataList14: [
        { value: "1", name: "≤100" },
        { value: "2", name: "101-500" },
        { value: "4", name: "501-999" },
        { value: "8", name: "≥1000" },
      ],
      dataList15: [
        { value: "1", name: "无污染" },
        { value: "2", name: "切口伤" },
        { value: "4", name: "局部脓肿" },
        { value: "8", name: "大量污染物、脓或血" },
      ],
      dataList16: [
        { value: "1", name: "无" },
        { value: "2", name: "仅原发病灶" },
        { value: "4", name: "淋巴结转移" },
        { value: "8", name: "远处转移" },
      ],
      dataList17: [
        { value: "1", name: "择期手术" },
        { value: "4", name: "急诊＞2h或入院后＜24h" },
        { value: "8", name: "立即手术（发病2h内手术）" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let form1 = JSON.parse(JSON.stringify(self.form1));
      let flag = true;
      let result = 0;
      let result1 = 0;
      let syndrome = 0;
      let mortality = 0;
      let possum = 0;
      let outnputValue1 = null;
      let outnputValue2 = null;
      let outnputValue3 = null;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      for (const key in form1) {
        if (form1.hasOwnProperty(key)) {
          if (!form1[key]) {
            flag = false;
          } else {
            form1[key] = Number(form1[key]);
          }
        }
        result1 += Number(form1[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        syndrome = (-5.91 + 0.16 * result + 0.19 * result1).toFixed(2);
        mortality = (-7.04 + 0.13 * result + 0.16 * result1).toFixed(2);
        possum = (-9.37 + 0.19 * result + 0.15 * result1).toFixed(2);
        outnputValue1 = (
          (Math.pow(Math.E, syndrome) / (1 + Math.pow(Math.E, syndrome))) *
          100
        ).toFixed(0);
        outnputValue2 = (
          (Math.pow(Math.E, mortality) / (1 + Math.pow(Math.E, mortality))) *
          100
        ).toFixed(0);
        outnputValue3 = (
          (Math.pow(Math.E, possum) / (1 + Math.pow(Math.E, possum))) *
          100
        ).toFixed(0);
        return {
          result,
          result1,
          outnputValue1,
          outnputValue2,
          outnputValue3,
        };
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/POSSUMandPPOSSUM.vue